import {useNavigate} from "react-router-dom";
import {AuthScreen} from "shared-lib";
import {Typography, Container} from "@mui/material";

const Login = () => {
  const navigate = useNavigate();

  const handleAuthSuccess = () => {
    navigate("/");
  };

  const handleAuthError = (error: Error) => {
    console.error("Authentication error:", error);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
      <Typography
        variant="h5"
        component="h1"
        gutterBottom
        sx={{
          color: "#101D3B",
          fontWeight: 700,
          textAlign: "center",
        }}>
        Rent Ready Bids Vendor Portal
      </Typography>
      <AuthScreen onSuccess={handleAuthSuccess} onError={handleAuthError} />
    </Container>
  );
};

export default Login;
